// declaration of all action types for books slice here

export const BOOKS_LOADED = 'books/booksLoaded';
export const BOOK_ADDED = 'books/bookAdded';
export const BOOK_DELETED = 'books/bookDeleted';
export const BOOK_UPDATED = 'books/bookUpdated';
export const GET_BOOK_DETAILS = 'books/getBookDetails';